import { render, staticRenderFns } from "./inbound-call-inprogress-icon.vue?vue&type=template&id=01e01e96"
import script from "./inbound-call-inprogress-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-inprogress-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports